export const DEPARTMENT_COLORS = {
    IT: 'CE8AFB',
    ALS: 'E83181',
    EMRG: '00D2D3',
    FAC: '58E7B2',
    OPS: '9EEA28',
    FLD: 'ECE928',
};

export function departmentColorCode(name, stored) {
    const raw = DEPARTMENT_COLORS[name] || stored || '999999';
    return String(raw).replace('#', '');
}

export function departmentChipTextColor(hex) {
    const raw = String(hex).replace('#', '');
    const channels = [0, 2, 4].map((start) => parseInt(raw.slice(start, start + 2), 16) / 255);
    const linear = (channel) => (channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4);
    const [red, green, blue] = channels.map(linear);
    const luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
    return (1.05 / (luminance + 0.05)) >= 4.5 ? '#ffffff' : '#0F1110';
}
